export default __webpack_public_path__ + "static/media/generated-by-ai-icon.21f0b0c9.svg";